export enum SeverityLevelsEnum {
  ERROR = 'Feil',
  WARNING = 'Advarsel',
  SUCCESS = 'Suksess',
  INFORMATION = 'Informasjon',
}

export enum InputType {
  DATE,
  EMAIL,
  FLOAT,
  INTEGER,
  LICENSE_PLATE,
  ORGANIZATION_NUMBER,
  PERSONAL_IDENTITY_NUMBER,
  PHONE_NUMBER,
  TEXT_AREA,
  TEXT_LINE,
  TIME,
  ZIP_CODE,
  MONTH,
  COPY_TEXT,
  YEAR,
}

export enum BosColors {
  Black = '#191919',
  Blue = '#4ba9c9',
  Blue20 = '#e9f5f9',
  CitroenBlack = '#3B3938',
  CitroenRedAlpha10 = '#DA291C1A',
  Concrete = '#4a4e54',
  DarkBlue = '#30306f',
  KiaBlack = '#05141F',
  KiaGreenAlpha10 = '#5D7D2B1A',
  LightGray = '#e1e1e1',
  LightGrey = '#f3f3f3',
  MercedesBlueTint = '#E6F5FF',
  MercedesHighlight = '#00ADEF',
  NeutralGrey = '#e3e3e3',
  NeutralPlus = '#b1b1b1',
  OpelBrightYellow = '#F7FF14',
  PeugeotBlueAlpha12 = '#0074e81f',
  PureBlack = '#000000',
  PureWhite = '#FFFFFF',
  SlateBlue = '#57718A',
  SmartBlack = '#141414',
  SmartLime = '#d7e600',
  SmartLimeAlpha10 = '#d7e6001a',
  SmartLimeAlpha60 = '#d7e60099',
  SmartSilver = '#969da3',
  White = '#fcfcfc',
}
